import React from 'react';

const COLORS = {
  primary: '#0080FF',
  text: '#475569',
  textDark: '#1f2937',
  textLight: '#64748b',
  bubbleUser: '#0080FF',
  bubbleAssistant: '#F2F2F2',
};

function renderFormattedContent(content) {
  if (!content) return null;

  const parts = content.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      const text = part.slice(2, -2);
      return (
        <strong key={index} style={{ fontWeight: 700 }}>
          {text}
        </strong>
      );
    }
    return (
      <span key={index}>
        {part.split('\n').map((line, i, arr) => (
          <React.Fragment key={i}>
            {line}
            {i < arr.length - 1 && <br />}
          </React.Fragment>
        ))}
      </span>
    );
  });
}

export function CopilotMessage({ message }) {
  const isUser = message.role === 'user';
  const isAssistant = message.role === 'assistant';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        marginBottom: '12px',
      }}
    >
      <div
        style={{
          maxWidth: '85%',
          padding: '10px 14px',
          borderRadius: '12px',
          backgroundColor: isUser ? COLORS.bubbleUser : COLORS.bubbleAssistant,
          color: isUser ? '#FFFFFF' : COLORS.textDark,
          fontSize: '14px',
          lineHeight: '1.5',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {renderFormattedContent(message.content)}

        {isAssistant && message.tool_calls?.length > 0 && (
          <div
            style={{
              marginTop: '8px',
              fontSize: '12px',
              color: isUser ? 'rgba(255,255,255,0.85)' : COLORS.textLight,
            }}
          >
            Running {message.tool_calls.length} tool
            {message.tool_calls.length > 1 ? 's' : ''}...
          </div>
        )}
      </div>
    </div>
  );
}
